/**
 * Application/root-level routes and composition of module route trees.
 * Only routes that are not owned by a specific module belong here directly
 * (e.g. not-found, and future shell routes such as /login, /terms,
 * /privacy). Each module owns and exports its own route tree from
 * `modules/<name>/routes.ts`; this file composes them under the root route.
 */
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from './rootRoute';
import { connectivityRouteTree } from '../../modules/connectivity';
import { monitoringRouteTree } from '../../modules/monitoring';

const WelcomePage = lazy(() =>
  import('../shell/WelcomePage').then((module) => ({
    default: module.WelcomePage,
  })),
);
const NotFoundPage = lazy(() => import('../shell/NotFoundPage'));

const welcomeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: WelcomePage,
});

const notFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '*',
  component: NotFoundPage,
});

export const routeTree = rootRoute.addChildren([
  welcomeRoute,
  connectivityRouteTree,
  monitoringRouteTree,
  notFoundRoute,
]);
